import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { DatePipe } from '@angular/common';

@Component({
	selector: 'lib-explorer-preview-fallback',
	imports: [DatePipe],
	changeDetection: ChangeDetectionStrategy.OnPush,
	template: `
		@let r = resource();
		@if (r) {
			<div class="flex flex-col gap-4 p-4">
				<h3 class="text-base-content text-lg font-bold">{{ r['name'] || r['title'] || r['publicFilename'] || r['id'] }}</h3>
				<div class="text-base-content/60 flex flex-col gap-1 text-sm">
					<div class="flex justify-between">
						<span class="font-medium">Kind</span>
						<span class="badge badge-ghost badge-sm">{{ r['kind'] }}</span>
					</div>
					@if (r['timeCreated']) {
						<div class="flex justify-between">
							<span class="font-medium">Created</span>
							<span>{{ $any(r['timeCreated']) | date: 'medium' }}</span>
						</div>
					}
					@if (r['timeUpdated']) {
						<div class="flex justify-between">
							<span class="font-medium">Modified</span>
							<span>{{ $any(r['timeUpdated']) | date: 'medium' }}</span>
						</div>
					}
					<div class="flex justify-between">
						<span class="font-medium">ID</span>
						<span class="font-mono text-xs opacity-50">{{ r['id'] }}</span>
					</div>
				</div>
			</div>
		}
	`,
})
export class ExplorerPreviewFallbackComponent {
	resource = input<Record<string, unknown> | null>(null);
}
